
<template>
    <div class="p10" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="6">
                <h1 style="padding-top:5px;">{{pageName}}</h1>
                
            </el-col>
            <el-col :span="18" class="tr">
                <template v-if="buttonsConfig.btnSingle">
                    <ly-button-single v-for="(btn, i) in buttonsConfig.btnSingle" :key="i"
                    :config="btn" 
                    :info-data="infoData" @operDone="useCallback"></ly-button-single>
                </template>
                <template v-if="buttonsConfig.isUse">
                    <ly-button-use :info-id="infoId" :status="infoData.is_delete" :callback="useCallback"></ly-button-use>
                </template>
                <template v-if="buttonsConfig.isCopy">
                    <ly-button-copy :infoid="infoId" v-if="infoData.status == 1 || infoData.status == 2"></ly-button-copy>
                </template>
                <template v-if="buttonsConfig.isXiaoshou">
                    <ly-button-xiaoshou :info-id="infoId" :disabled="editBtnDisabled" :callback="xiaoshouCallback"></ly-button-xiaoshou>
                </template>
                <template v-if="buttonsConfig.isDelete">
                    <ly-button-delete :info-id="infoId" size="small" :callback="DeleteCallback"></ly-button-delete>
                </template>
                <template v-if="buttonsConfig.isInvalid">
                    <ly-bntton-invalid 
                        size="small"
                        :info-id="infoId"
                        :is-route="currRoute.api"
                        :is-style="pageName"
                        :callback="invalidCallback"
                        :isdisabled="editBtnDisabled">
                    </ly-bntton-invalid>
                </template>
                <template v-if="buttonsConfig.isExamine">
                    <ly-button-examine
                        :info-id="infoId"
                        :route="currRoute.api"
                        :callback="examineCallback"
                        :disabled="infoData.status == 2"
                        v-if="infoData.status != 11">
                    </ly-button-examine>
                </template>
                <template v-if="buttonsConfig.isEdit">
                    <ly-router-button
                        size="small"
                        :route="'/bill/' + currRoute.path + '/edit/' + infoId"
                        type="primary"
                        :disabled="editBtnDisabled">
                            <i class="fa fa-edit"></i>&nbsp;修改
                    </ly-router-button>
                </template>
                <template v-if="buttonsConfig.isSBPrint">
                    <sb-print :info="infoData"></sb-print>
                </template>
                <template v-if="buttonsConfig.isBack">
                    <ly-router-button size="small">
                        <i class="fa fa-chevron-left"></i>&nbsp;返回
                    </ly-router-button>
                </template>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <el-card class="box-card mt15">
            <!-- <div slot="header"> -->
            <el-row>
                <el-col :span="12">
                    <el-button-group>
                        <template v-if="infoData.last_id && infoData.last_id > 0">
                            <el-button type="info" size="small" @click="toggoleInfo(infoData.last_id)">
                                <i class="fa fa-chevron-left"></i> 前一张
                            </el-button>
                        </template>
                        <template v-if="infoData.next_id && infoData.next_id > 0">
                            <el-button type="info" size="small" @click="toggoleInfo(infoData.next_id)">
                                后一张 <i class="fa fa-chevron-right"></i> 
                            </el-button>
                        </template>
                    </el-button-group>
                    <template v-if="buttonsConfig.stream && 
                        buttonsConfig.stream.url &&  
                        buttonsConfig.stream.url.length > 0 &&
                        infoData.guanlian_id">
                        <template v-if="currRoute.path == 'checkout'">
                            <a
                                target="_blank"
                                :href="buttonsConfig.stream.url + infoData.guanlian_id"
                                class="el-button el-button--success el-button--small"
                                :title="buttonsConfig.stream.label"
                                v-if="userInfo.is_hidden != 1"
                                >
                                {{buttonsConfig.stream.label}}
                            </a>
                        </template>
                        <template v-else>
                            <el-button 
                                class="el-button el-button--success el-button--small"
                                @click="routerJump(buttonsConfig.stream.url + infoData.guanlian_id)">
                                {{buttonsConfig.stream.label}}
                            </el-button>
                        </template>
                    </template>
                </el-col>
                <el-col :span="12" class="tr">
                    <template v-if="infoData.status">
                        <ly-tag tag-category="bd_status" :tag-status="infoData.status"></ly-tag>
                    </template>
                    <template v-if="infoData.is_yinyong">
                        <ly-tag tag-category="sb_yinyong" :tag-status="infoData.is_yinyong"></ly-tag>
                    </template>
                    <template v-if="infoData.xs_status">
                        <ly-tag tag-category="xs_status" :tag-status="infoData.is_xiaoshou"></ly-tag>
                    </template>
                    <!--收款账户详情增加现金收款tag 2018-5-17 by wxf-->
                    <template v-if="infoData.is_cash">
                        <ly-tag tag-category="bankaccount" :tag-status="infoData.is_cash"></ly-tag>
                    </template>
                </el-col>
            </el-row>
            <!-- </div> -->
            <!-- 单据信息 start -->
            <ly-information 
                :config="infoConfig"
                :data="infoData"
                class="mt15">        
            </ly-information>
            <!-- 单据信息 end -->

        </el-card>
        <!-- <el-card class="box-card mt15"> -->
            <!-- 货品列表 start -->
            <ly-table 
                :head="productConfig.head" 
                :data="infoData.product" 
                :config="productConfig.config"
                class="mt15"
                v-if="productConfig.isExist != false">
            </ly-table>
            <!-- 货品列表 end -->
        <!-- </el-card> -->
        <!-- 图片附件 start -->
        <ly-img-upload 
            :id="infoId"
            :api="uploadConfig.api"
            :data="uploadConfig.data"
            :list="infoData.upload || []"
            v-if="uploadConfig && uploadConfig.api">
        </ly-img-upload>
        <!-- 图片附件  end  -->
        <el-card class="box-card mt15" v-if="infoData.history && infoData.history.length > 0">
            <template slot='header'>
            <div>
                <span>处理记录</span>
            </div>
            </template>
            <p class="f12 mt10 ctext" v-for="el in infoData.history">
                {{el}}
             </p>
        </el-card>
    </div>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex'
    import LyInformation from '@c/information'
    import LyTable from '@c/table'
    import LyButtonCopy from '@c/button-copy'
    import LyBnttonInvalid from '@c/button-invalid'
    import LyButtonExamine from '@c/button-examine'
    import LyRouterButton from '@c/router-button'
    import LyButtonXiaoshou from '@c/button-xiaoshou'
    import LyButtonDelete from '@c/button-delete'
    import LyButtonSingle from '@c/button-single'
    import LyButtonUse from '@c/button-use'
    import LyImgUpload from '@c/img-upload'
    import LyTag from '@c/tag'
    import SbPrint from './print';
    export default {
        components: {
            SbPrint,
            LyInformation,
            LyTable,
            LyButtonCopy,
            LyBnttonInvalid,
            LyButtonExamine,
            LyRouterButton,
            LyButtonXiaoshou,
            LyButtonUse,
            LyTag,
            LyImgUpload,
            LyButtonDelete,
            LyButtonSingle
        },
        computed: {
            ...mapGetters(['userInfo']),
            ...mapGetters('route', [
                'currRoute'
            ]),
            // 修改的路由
            editRoute () {
                return '/bill/' + this.currRoute.path + '/edit/' + this.infoId
            },
            // 作废按钮的隐藏与显示的控制
            invalidBtnDisabled () {
                return String(this.infoData.status) === '11'
            },
            /**
             * 2017-09-30修改
             * 作废和修改的状态是一样的，不能作废的同时也不能修改，不能修改的话也不能作废
             */
            // 修改按钮的隐藏与显示的控制
            editBtnDisabled () {
                let bool = false
                // 作废状态和已审核不能修改
                if (String(this.infoData.status) === '11') {
                    bool = true
                }
                //  1、三包登记 2017-11-03修改，已审核已被引用下 不可以作废和修改
                //  2、三包理赔 2017-11-03修改，已审核 不可修改和作废
                //  这里要根据路由判断，破坏了info 页面的通用性，作废和修改是否显示，后续应该通过数据中的标识来判断，而不是前端用各种条件判断
                // 2017-11－03下游单号状态不为1的时候 就不能修改
                if (this.currRoute.path === 'checkin') {
                    if (String(this.infoData.status) === '2' && String(this.infoData.is_yinyong) === '1' && String(this.infoData.xiayouStatus) !== '1') {
                        bool = true
                    }
                } else if (this.currRoute.path === 'checkout') {
                    if (String(this.infoData.status) === '2' && String(this.infoData.xiayouStatus) !== '1') {
                        bool = true
                    }
                } else {
                    if (String(this.infoData.status) === '2') {
                        bool = true
                    }
                }
                if (!bool && this.infoData.xiaoshou_type) {
                    // 销售单已存在不能修改
                    if (String(this.infoData.xiaoshou_type) === '1') {
                        bool = true
                    }
                }
                return bool
            }
        },
        data () {
            return {
                infoId: 0, // 详情的ID
                pageName: '',
                uploadConfig: {}, // 图片上传的配置
                buttonsConfig: {}, // 按钮的配置
                productConfig: {}, // 货品列表的配置
                infoConfig : [], // 详情信息的配置
                infoData: {}, // 详情的数据，包含货品数据、处理记录
                loading: false
            }
        },
        mounted () {
            this.readRouteConfig()
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'BillInfo') {
                    this.readRouteConfig()
                }
            }
        },
        methods: {
            ...mapActions('route', [
                'updateCurrRoute'
            ]),
            /**
             * 读取路由的详情配置
             */
            readRouteConfig () {
                // 获取详情的ID
                this.infoId = this.$route.params.id
                if (this.infoId) {
                    // 获得当前页面的配置
                    let routeConfig = this.$utils.readRouteConfig(this.$route.fullPath)
                    // 更新当前路由对象
                    this.updateCurrRoute(routeConfig)
                    // 获得当前页面的配置
                    let config = this.$utils.readPageConfig(this.currRoute, 'info')
                    // 当前页面的组件配置
                    config = config ? config.config : null
                    // 获得当前页面的名称
                    this.pageName = this.currRoute ? this.currRoute.name : ''
                    if (config) {
                        this.loading = true
                        // 获得商品的配置
                        this.uploadConfig = JSON.parse(config.upload || '[]')
                        // 获得按钮的配置
                        this.buttonsConfig = JSON.parse(config.button || '[]')
                        // 获得详情的配置
                        this.infoConfig = JSON.parse(config.info || '[]')
                        // 获得货品的配置
                        this.productConfig = JSON.parse(config.product || '[]')
                        // 进行数据的获取
                        this.queryInfoData()
                    } else {
                        this.$alert('请重试 或 询问管理员是否为你授权', '未检测到当前页面配置', {
                            confirmButtonText: '确定',
                              callback: action => {
                              }
                        })
                    }
                } else {
                    this.loading = false
                    this.$message({
                        message: '无ID',
                        type: 'warning'
                    })
                }
            },
            /**
             * 获取详情的数据
             */
            queryInfoData () {
                this.$api.query(this.currRoute.api ,{
                    route: this.currRoute.path
                    // info: this.getField(this.infoConfig), // 获取详情需要的字段
                    // product: this.getField(this.productConfig.head) // 获取货品中需要的字段
                }, [this.infoId]).then((rs) => {
                    this.loading = false
                    this.infoData = rs
                }).catch((error) => {
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 获取对象上的字段
             * @param  {[Array]} list [对象列表]
             * @return {[Array]}      [字段集合]
             */
            getField (list) {
                let arr = []
                for (let i in list) {
                    if (list[i]['prop']) {
                        arr.push(list[i]['prop'])
                    }
                }
                return arr
            },
            /**
             * 详情页面的切换
             */
            toggoleInfo (id) {
                // 跳转到的路由
                let path = '/bill/' + this.currRoute.path + '/info/' + id
                this.routerJump(path)
            },
            /**
             * 路由跳转处理
             * @param  {[type]} path [description]
             * @return {[type]}      [description]
             */
            routerJump (path) {
                path = path.replace('#', '')
                this.loading = true
                this.$router.push(path)
            },
            /**
             * 作废成功后的回调
             */
            invalidCallback () {
                // 改变当前单据状态
                this.$set(this.infoData, 'status', 11)
            },
            /**
             * 审核成功后的回调
             */
            examineCallback () {
                // 改变当前单据状态
                this.$set(this.infoData, 'status', 2)
            },
            /**
             * 生成销售单据后的回调
             */
            xiaoshouCallback (id) {
                this.readRouteConfig()
                // this.$set(this.infoData, 'xiaoshou_type', 1)
                // this.$set(this.infoData, 'guanlian_id', id)
            },
            /**
             * 删除开票信息
             */
            DeleteCallback () {
                this.readRouteConfig()
            },
            /**
             * 停用启用按钮的回调处理
             */
            useCallback (bool) {
                // 重新获得数据
                this.readRouteConfig()
                // this.$set(this.infoData, 'is_delete', bool)
            }
        }
    }
</script>